import { useEffect, useRef, useCallback } from 'react';
import { isBrowser } from '@zapier/common-utils';
import { TrackPropsType } from '../types';

function useCountClicks(
  { track, trackingMessage, trackingProps }: TrackPropsType = {
    track: () => {},
  }
) {
  const clicksRef = useRef(0);

  function incrementClicks() {
    clicksRef.current += 1;
  }

  function onComponentUnmount() {
    const message = trackingMessage || 'track click';
    track(message, {
      ...(trackingProps || {}),
      number_of_clicks_on_refresh_close_or_navigate_away: clicksRef.current,
    });

    window.removeEventListener('click', incrementClicks);
    window.removeEventListener('beforeunload', onComponentUnmount);
  }

  const onComponentUnmountCallback = useCallback(onComponentUnmount, []);

  useEffect(() => {
    if (isBrowser()) {
      window.addEventListener('click', incrementClicks);
      window.addEventListener('beforeunload', onComponentUnmountCallback);
    }

    // will be called on component unmount
    return () => {
      if (isBrowser()) {
        onComponentUnmountCallback();
      }
    };
  }, [onComponentUnmountCallback]);
}

export default useCountClicks;
